const getExtraAdherentConsentementTelText = (value) => value;

export default getExtraAdherentConsentementTelText;
